module.exports = __webpack_public_path__ + "img/symbol_6.f29092e6.png";